<template>
  <section class="jd-similar hp-animate">
    <div class="jd-similar__head">
      <h2 class="jd-section-title">Similar jobs</h2>
    </div>

    <div v-if="loading" class="jd-similar__grid">
      <div class="hp-job-card hp-job-card--skeleton" v-for="n in 4" :key="n">
        <content-loader viewBox="0 0 300 140" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
          <rect x="0" y="0" rx="8" ry="8" width="40" height="40" />
          <rect x="0" y="56" rx="4" ry="4" width="200" height="14" />
          <rect x="0" y="78" rx="4" ry="4" width="120" height="10" />
        </content-loader>
      </div>
    </div>

    <div v-else-if="jobs.length" class="jd-similar__grid">
      <JobCardCompact
        v-for="item in jobs.slice(0, show)"
        :key="item.job_id"
        :job="item"
      />
    </div>

    <div class="jd-similar__more" v-if="!loading && jobs.length && filterLimit < 10">
      <button type="button" class="hp-btn hp-btn--outline" @click="$emit('load-more')">Load more</button>
    </div>
  </section>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import JobCardCompact from '@/components/JobCardCompact.vue';

export default {
  name: 'JobDetailSimilar',
  components: { ContentLoader, JobCardCompact },
  props: {
    jobs: { type: Array, default: () => [] },
    loading: { type: Boolean, default: true },
    show: { type: Number, default: 4 },
    filterLimit: { type: Number, default: 9 },
  },
};
</script>
